module.exports = __webpack_public_path__ + "img/edit.eb5f825b.svg";